var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithNote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8335 16.5H11.0002V18.3333H1.8335V16.5ZM1.8335 10.0833H20.1668V11.9166H1.8335V10.0833ZM1.8335 3.66663H20.1668V5.49996H1.8335V3.66663ZM16.5002 16.5V13.75H18.3335V16.5H21.0835V18.3333H18.3335V21.0833H16.5002V18.3333H13.7502V16.5H16.5002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithNote);
export default __webpack_public_path__ + "static/media/with-note.355dc3b810bc414b282590bfb48a142d.svg";
export { ForwardRef as ReactComponent };